export default "__VITE_ASSET__DJxjK3t1__"